angular.module('app').directive('modalGaleria', function ($http) {
    return {
        restrict: 'E',
        templateUrl: '/html/modal-galeria.html?v=' + angular.element('meta[name="version-id"]').attr('content'),
        scope: {
            vitrines: '=',
            bannerWidth: '@',
            bannerHeight: '@',
        },
        controller: function ($scope, $timeout) {
            $scope.cropper;
            $scope.novaImagemCtrl = {};
            $scope.novoVideoCtrl = {};
            $scope.sortableOptions = {
                helper: "clone",
                axis: "x",
                forcePlaceholderSize: true,
                placeholder: "sortable-placeholder",
                handle: ".btn-reorganizar",
                stop: function () {
                    onYouTubeIframeAPIReady();
                }
            }

            $scope.init = function () {
                $scope.novaImagemCtrl = {
                    cropperReady: false,
                    temp: '',
                    b64: '',
                };

                $scope.novoVideoCtrl = {
                    url: ''
                };
            }

            $scope.zoomTimeout;

            $scope.action = 'inicial';
            $scope.novaImagemSrc = '';

            $scope.novaImagem = function () {

                $scope.action = 'nova-imagem';
            }

            $scope.novoVideo = function () {
                if ($scope.vitrines.length >= 3) {
                    alert('Limite de imagens/vídeos atingido.');
                    return false;
                }
                $scope.action = 'novo-video';
            }

            $scope.irParaInicial = function () {
                $scope.action = 'inicial';
                $scope.init();
            }

            $scope.preAddBanner = function () {

                $scope.getBase64($scope.novaImagemCtrl.temp).then(function (res) {

                    $scope.novaImagemCtrl = {
                        ...$scope.novaImagemCtrl,
                        cropperReady: false,
                        temp: '',
                        b64: res,
                    };


                    $scope.novaImagem();

                    $timeout(() => {
                        if ($scope.cropper) {
                            $scope.cropper.replace($scope.novaImagemCtrl.b64);
                            return;
                        }
                        const image = document.getElementById('cropperjs-img');

                        image.addEventListener('ready', function () {
                            if ($scope.cropper && this.cropper === $scope.cropper) {
                                $scope.novaImagemCtrl.cropperReady = true;
                            }
                        });

                        image.setAttribute('src', $scope.novaImagemCtrl.b64);

                        $scope.cropper = new Cropper(image, {
                            aspectRatio: 16 / 9,
                            minCropBoxWidth: $scope.bannerWidth,
                            minCropBoxHeight: $scope.bannerHeight,
                            viewMode: 1,
                            dragMode: 'move',
                            cropBoxResizable: false,
                            cropBoxMovable: false,

                        });
                    }, 500);

                });
            };

            $scope.getBase64 = function (file) {
                var p = new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function () {
                        resolve(reader.result);
                    };
                    reader.onerror = function (error) {
                        reject(error);
                    };
                });

                return p;
            };

            $scope.adicionar = function () {

                const tipo = $scope.action === 'nova-imagem' ? 'imagem' : 'youtube';

                if (tipo === 'youtube') {
                    if (!$scope.validateYouTubeUrl($scope.novoVideoCtrl.url)) {
                        $.gritter.add({
                            title: 'Preencha os campos corretamente:',
                            text: 'O link informado não é uma URL válida do youtube',
                            time: 5000,
                            class_name: 'erro'
                        });

                        return false;
                    }
                }

                const src = tipo === 'imagem' ? $scope.cropper.getCroppedCanvas().toDataURL() : $scope.getVideoIdFromYouTubeUrl($scope.novoVideoCtrl.url);

                $scope.vitrines.push({
                    tipo: tipo,
                    data_src: src,
                });
                /*
                                $timeout(function () {
                                    console.log('oi2');
                                    $('.youtube-player-container').each(function () {
                                        console.log($(this));
                
                                        window.YTVideos.add($(this));
                                    });
                
                                    window.YTVideos.loadApi();
                                }, 1500);*/

                $scope.irParaInicial();

            }

            $scope.rmVitrine = function (ix) {
                if (!confirm('Deseja realmente excluir este item?')) {
                    return false;
                }
                $scope.vitrines.splice(ix, 1);
            }

            $scope.getVideoIdFromYouTubeUrl = function (url) {
                if (url != undefined || url != '') {
                    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
                    var match = url.match(regExp);
                    if (match && match[2].length == 11) {
                        return match[2];
                    }
                }

                return '';
            }

            $scope.validateYouTubeUrl = function (url) {
                if (url != undefined || url != '') {
                    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
                    var match = url.match(regExp);
                    if (match && match[2].length == 11) {
                        // Do anything for being valid
                        // if need to change the url to embed url then use below line
                        return true;
                    }
                }

                return false;
            }

            $scope.onChangeZoomSlider = function (direcao) {
                if (direcao === '+') {
                    $scope.cropper.zoom(0.1)
                } else {
                    $scope.cropper.zoom(-0.1)
                }
            }
        },
        link: function ($scope) {
            $('#modal-galeria').on('show.bs.modal', function () {
                $scope.init();
            });
        }
    };
});